// extracted by mini-css-extract-plugin
export default {"loader_container":"loader_container___RXTdn","loader":"loader___iB3h2","shown":"shown___lyQdi"};